import PropTypes from "prop-types";

import Link from "next/link";

export default function TestHeader({ testDetails, selectedTest }) {
    const { configProductCard } = testDetails || {};
    const { categoryType, category, categorySlug } = configProductCard || {};

    const pathName =
        categoryType === "packages"
            ? "/health-packages"
            : `/facilities/${categorySlug}`;

    const categoryMap = {
        lab: "",
        scan: "Scan | ",
        packages: "Health Package | ",
    };

    const subTittle = `${
        categoryMap[categoryType] || "Other Test | "
    }${category}`;

    const total = selectedTest?.rate;
    const mrp = selectedTest?.mrp;
    return (
        <section className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
            <Link
                href={{
                    pathname: pathName,
                }}
                className="inline-flex text-xs font-semibold uppercase tracking-wider text-primary underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 rounded-sm"
            >
                {subTittle}
            </Link>

            <div className="mt-1.5 flex items-start justify-between gap-4">
                <h1 className="text-xl font-bold leading-snug tracking-tight text-slate-900">
                    {testDetails?.productName}
                </h1>

                {!mrp && !total ? null : (
                    <div className="shrink-0 text-right">
                        <p className="text-xs leading-5 text-slate-400 line-through">
                            ₹{mrp}
                        </p>
                        <p className="text-xl font-bold leading-tight text-slate-900">
                            ₹{total}
                        </p>
                    </div>
                )}
            </div>
        </section>
    );
}

TestHeader.propTypes = {
    testName: PropTypes.string,
    subTittle: PropTypes.string,
    total: PropTypes.number,
    mrp: PropTypes.number,
    icon: PropTypes.element,
    color: PropTypes.string,
    keywords: PropTypes.array,
    description: PropTypes.string,
};
